export interface MethodOption {
    title: string;
    value: string;
}

export interface MethodGroup {
    label: string;
    options: MethodOption[];
}

export const MethodOptions: MethodGroup[] = [
    {
        label: 'Alientech',
        options: [
            {
                title: 'Alientech Kess3 OBD',
                value: 'Alientech Kess3 OBD'
            },
            {
                title: 'Alientech Kess3 Bench',
                value: 'Alientech Kess3 Bench'
            },
            {
                title: 'Alientech Kess3 Boot',
                value: 'Alientech Kess3 Boot'
            }
        ]
    },
    {
        label: 'Autotuner',
        options: [
            {
                title: 'Autotuner Bench',
                value: 'Autotuner Bench'
            },
            {
                title: 'Autotuner Boot',
                value: 'Autotuner Boot'
            },
            {
                title: 'Autotuner OBD',
                value: 'Autotuner OBD'
            }
        ]
    },
    {
        label: 'bFlash',
        options: [
            {
                title: 'bFlash Bench',
                value: 'bFlash Bench'
            },
            {
                title: 'bFlash Boot',
                value: 'bFlash Boot'
            },
            {
                title: 'bFlash OBD',
                value: 'bFlash OBD'
            }
        ]
    },
    {
        label: 'CMD',
        options: [
            {
                title: 'CMD Bench',
                value: 'CMD Bench'
            },
            {
                title: 'CMD Boot Tricore',
                value: 'CMD Boot Tricore'
            },
            {
                title: 'CMD Flash',
                value: 'CMD Flash'
            }
        ]
    },
    {
        label: 'Dimsport',
        options: [
            {
                title: 'Dimsport New Genius',
                value: 'Dimsport New Genius'
            },
            {
                title: 'Dimsport Trasdata',
                value: 'Dimsport Trasdata'
            }
        ]
    },
    {
        label: 'MagicMotorsport',
        options: [
            {
                title: 'Flex Bench',
                value: 'Flex Bench'
            },
            {
                title: 'Flex Boot',
                value: 'Flex Boot'
            },
            {
                title: 'Flex OBD',
                value: 'Flex OBD'
            },
            {
                title: 'X17 Boot',
                value: 'X17 Boot'
            },
            {
                title: 'X17 OBD',
                value: 'X17 OBD'
            }
        ]
    },
    {
        label: 'PCM Flash',
        options: [
            {
                title: 'PCM Flash',
                value: 'PCM Flash'
            }
        ]
    },
    {
        label: 'Others',
        options: [
            {
                title: 'Others',
                value: 'Others'
            }
        ]
    }
];

export const SimpleMethodOptions: MethodOption[] = [
    {
        title: 'bFlash',
        value: 'bflash'
    },
    {
        title: 'Alientech',
        value: 'alientech'
    },
    {
        title: 'Autotuner',
        value: 'autotuner'
    },
    {
        title: 'CMD',
        value: 'cmd'
    },
    {
        title: 'Dimsport',
        value: 'dimsport'
    },
    {
        title: 'MagicMotorsport',
        value: 'magicmotorsport'
    },
    {
        title: 'PCM Flash',
        value: 'pcmflash'
    },
    {
        title: 'Autres',
        value: 'others'
    }
];

export const TechniqueOptions: MethodOption[] = [
    {
        title: 'OBD',
        value: 'obd'
    },
    {
        title: 'Bench',
        value: 'bench'
    },
    {
        title: 'Boot',
        value: 'boot'
    }
];

export const MasterSlaveOptions: MethodOption[] = [
    {
        title: 'Master',
        value: 'master'
    },
    {
        title: 'Slave',
        value: 'slave'
    }
];